import { FaUser } from 'react-icons/fa';
import { RiLockPasswordFill } from 'react-icons/ri';
import { BsFillEyeFill, BsFillEyeSlashFill, BsFillKeyFill } from 'react-icons/bs';
import { Button, Form } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../Context/globalContext';
import { toast } from 'react-toastify';
import { ref, onValue } from 'firebase/database';
import FirebaseApp from '../firebase';
import backgroundImg from "../Assets/img/bgi.png"

export const Login = () => {

    const globalContext = useContext(GlobalContext);
    const [payload, setPayload] = useState({ company_name: '', key: '', password: '', showPass: false });
    const [data, setData] = useState([])

    useEffect(() => {
        globalContext.setLoader(true);
        FirebaseApp().then(db => {
            const dbRef = ref(db, "CompanyKeys");
            return onValue(dbRef, (snapshot) => {
                console.log("Table get connected");
                let records = []
                snapshot.forEach(childSnapshot => {
                    if (childSnapshot.val().key_status) {
                        records.push({ "key": childSnapshot.key, "company_name": childSnapshot.val().company_name, "available_licenses": childSnapshot.val().available_licenses, "total_licenses": childSnapshot.val().total_licenses, "company_password": childSnapshot.val().company_password })
                    }
                })
                setData(records)
                globalContext.setLoader(false);
            }, (error) => {
                globalContext.setLoader(false);
                console.log("Error while loading the data", error);
            });
        }).catch(error => {
            console.error("Error initializing Firebase:", error);
        })
    }, [])

    const onSubmit = (e) => {
        e.preventDefault();
        toast.dismiss();
        if (payload.company_name.trim() === '') {
            toast.error('Please enter company name.');
            return false
        } else if (payload.key.trim() === '') {
            toast.error('Please enter comany key.');
            return false
        } else if (payload.password.trim() === '') {
            toast.error('Please enter company password.');
        } else {
            globalContext.setLoader(true);
            let output = data.filter((d) => d.key === payload.key && d.company_name === payload.company_name && d.company_password === payload.password)
            if (output.length > 0) {
                globalContext.setCompanyName(payload.company_name)
                globalContext.setToken("token")
                sessionStorage.setItem('token', payload.key);
                sessionStorage.setItem('company_name', payload.company_name);
                setTimeout(() => { toast.success('Logged In Successfully.'); window.location.href = "/" }, 1000);
                globalContext.setLoader(false);
            } else {
                globalContext.setLoader(false);
                toast.error('Invalid Credentials')
            }
        }
    }


    return (
        <section className="w3l-workinghny-form" style={{ backgroundImage: `url(${backgroundImg})` }}>
            <div className="workinghny-form-grid">
                <div className="wrapper">
                    <div className="workinghny-block-grid">
                        <div className="workinghny-left-img align-end">
                            <img src={require('../Assets/img/2.png')} className="img-responsive" alt="img" />
                        </div>
                        <div className="form-right-inf">
                            <h1>LOGIN</h1>
                            <div className="login-form-content">
                                <Form className="signin-form">
                                    <Form.Group className="one-frm" controlId="exampleForm.ControlInput1">
                                        <Form.Label className='text-left'>Company Name</Form.Label>
                                        <div className='login-email position-relative'>
                                            <Form.Control type="text" placeholder="Enter company name" value={payload.company_name} onChange={(e) => setPayload({ ...payload, company_name: e.target.value })} onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    onSubmit(e)
                                                }
                                            }} />
                                            <FaUser />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="one-frm" controlId="exampleForm.ControlInput2">
                                        <Form.Label className='text-left'>Company Key</Form.Label>
                                        <div className='login-email position-relative'>
                                            <Form.Control type="text" placeholder="Enter company key" value={payload.key} onChange={(e) => setPayload({ ...payload, key: e.target.value })} onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    onSubmit(e)
                                                }
                                            }} />
                                            <BsFillKeyFill />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="one-frm" controlId="exampleForm.ControlPassword1">
                                        <Form.Label className='text-left'>Company Password</Form.Label>
                                        <div className='login-email position-relative'>
                                            <Form.Control type={payload.showPass ? "text" : "password"} placeholder="Enter company password" value={payload.password} onChange={(e) => setPayload({ ...payload, password: e.target.value })} onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    onSubmit(e)
                                                }
                                            }} />
                                            <RiLockPasswordFill />
                                            <a className='eye-btn' onClick={() => setPayload({ ...payload, showPass: !payload.showPass })}>{payload.showPass ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}</a>
                                        </div>
                                    </Form.Group>
                                    <Button className="btn btn-style mt-3" onClick={(e) => onSubmit(e)}>Login</Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}
